let path = 'static/help'
export default {
  ITEM1: {
    VIDEO: path + '/A1/vid.mp4'
  },
  ITEM2: {
    VIDEO: path + '/A2/vid.mp4'
  },
  ITEM3: {
    VIDEO: path + '/A3/vid.mp4'
  },
  ITEM4: {
    VIDEO: path + '/A4/vid.mp4'
  },
  ITEM5: {
    VIDEO: path + '/A5/vid.mp4'
  },
  ITEM6: {
    VIDEO: path + '/A6/vid.mp4'
  },
  ITEM7: {
    VIDEO: path + '/B1/vid.mp4'
  },
  ITEM8: {
    VIDEO: path + '/B2/vid.mp4'
  },
  ITEM9: {
    VIDEO: path + '/B3/vid.mp4'
  },
  ITEM10: {
    VIDEO: path + '/B4/vid.mp4'
  },
  ITEM11: {
    VIDEO: path + '/B5/vid.mp4'
  },
  ITEM12: {
    VIDEO: path + '/B6/vid.mp4'
  },
  ITEM13: {
    VIDEO: path + '/C1/vid.mp4'
  },
  ITEM14: {
    VIDEO: path + '/C2/vid.mp4'
  },
  ITEM15: {
    VIDEO: path + '/C3/vid.mp4'
  },
  ITEM16: {
    VIDEO: path + '/D1/vid.mp4'
  },
  ITEM17: {
    VIDEO: path + '/D2/vid.mp4'
  },
  ITEM18: {
    VIDEO: path + '/D3/vid.mp4'
  },
  ITEM19: {
    VIDEO: path + '/D4/vid.mp4'
  },
  ITEM20: {
    VIDEO: path + '/D5/vid.mp4'
  },
  ITEM21: {
    VIDEO: path + '/D6/vid.mp4'
  },
  ITEM22: {
    VIDEO: path + '/D7/vid.mp4'
  },
  ITEM23: {
    VIDEO: path + '/D8/vid.mp4'
  },
  ITEM24: {
    VIDEO: path + '/E1/vid.mp4'
  },
  ITEM25: {
    VIDEO: path + '/E2/vid.mp4'
  },
  ITEM26: {
    VIDEO: path + '/E3/vid.mp4'
  },
  ITEM27: {
    VIDEO: path + '/E4/vid.mp4'
  },
  ITEM28: {
    VIDEO: path + '/E5/vid.mp4'
  },
  ITEM29: {
    VIDEO: path + '/E6/vid.mp4'
  },
  ITEM30: {
    VIDEO: path + '/E7/vid.mp4'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/questionnaire/CA_QUESTIONNAIRE_HELP_ITEMS.js